module.exports = __webpack_public_path__ + "assets/img/t1.0e29a090.png";